import {
  FINISH_LOADING_APPLICATION,
  RESET_LOADING_APPLICATION,
  START_LOADING_APPLICATION,
} from "../action";

function loadingReducer(state = 0, action) {
  switch (action.type) {
    case START_LOADING_APPLICATION:
      return state + 1;
    case FINISH_LOADING_APPLICATION:
      if (state > 0) {
        return state - 1;
      } else {
        return state;
      }
    case RESET_LOADING_APPLICATION:
      return 0;
    default:
      return state;
  }
}

export default loadingReducer;
